// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__9EHQU","emails":"CreateEditClinics_emails__2sPxn","emailTagLabel":"CreateEditClinics_emailTagLabel__2h4aP"};